import { GlobalInit } from "./utils/GlobalInit";
import { Globals } from "./CoreApp/Globals";
import { gBrowserLink, gAppName, kImageFiles, brandModulePromise } from "./whitelabel/brand";
import { updateFavicon } from "@coreapp/utils/updateFavicon";
import { isMfeContext } from "@coreapp/utils/isMfeContext";
import { CreateCanvas } from "./utils/CreateCanvas";
import { handleMouseDown } from "./utils/handleMouseDown";
import { handleCut } from "./utils/handleCut";
import { handlePaste } from "./utils/handlePaste";
import { handleMouseUp } from "./utils/handleMouseUp";
import { handleMouseMove } from "./utils/handleMouseMove";
import { handleMouseEnter } from "./utils/handleMouseEnter";
import { handleDoubleClick } from "./utils/handleDoubleClick";
import { handleRightClick } from "./utils/handleRightClick";
import { handleKeyUp } from "./utils/handleKeyUp";
import { handleMouseWheel } from "./utils/handleMouseWheel";
import { handleKeyDown } from "./utils/handleKeyDown";
import { handleKeyPress } from "./utils/handleKeyPress";
import {
  handleCanvasBlur,
  handleCanvasFocus,
  handleCanvasPointerDown
} from "./utils/handleCanvasFocus";
import { handleCopy } from "./utils/handleCopy";
import { handleTouchEnd } from "./utils/handleTouchEnd";
import { handleTouchStart } from "./utils/handleTouchStart";
import { handleTouchMove } from "./utils/handleTouchMove";
import { handleGestureStart } from "./utils/handleGestureStart";
import { handleGestureEnd } from "./utils/handleGestureEnd";
import { handleGestureChange } from "./utils/handleGestureChange";
import { positionBaseCanvas } from "./utils/positionBaseCanvas";
import { handleDragEnter } from "./utils/handleDragEnter";
import { handleDragOver } from "./utils/handleDragOver";
import { handleDragLeave } from "./utils/handleDragLeave";
import { handleDragDrop } from "./utils/handleDragDrop";
import { handleMobileKeyboardInput } from "./utils/handleMobileKeyboardInput";
import { handleMobileKeyPress } from "./utils/handleMobileKeyPress";
import { handleMobileKeyDown } from "./utils/handleMobileKeyDown";
import { setupCanvas } from "./utils/setupCanvas";
import { DoSetOnBeforeUnload } from "./utils/DoSetOnBeforeUnload";

export const SubscribeExternalModuleReactAPI = function (reactContextSetStateFn, stateMgrID) {
  var curState;
  switch (stateMgrID) {
    case "wsmgr":
      curState = { state: Globals._wsMgr };
      if (Globals._wsMgr) {
        Globals._wsMgr.fReactContextProviderFn = reactContextSetStateFn;
        reactContextSetStateFn(curState);
        clearTimeout(Globals.gSubscriberId);
        return;
      }
      reactContextSetStateFn(curState);
      Globals.gSubscriberId = setTimeout(function () {
        SubscribeExternalModuleReactAPI(reactContextSetStateFn, stateMgrID);
      }, 100);
      break;
    case "planmgr":
      curState = { state: null };
      if (Globals._wsMgr) {
        curState = { state: Globals._wsMgr.GetPlanMgr() };
        Globals._wsMgr.fPlanMgrContextStateFn = reactContextSetStateFn["stateSetter"];
        return;
      }
      Globals.gSubscriberId = setTimeout(function () {
        SubscribeExternalModuleReactAPI(reactContextSetStateFn, stateMgrID);
      }, 100);
      break;
    case "doc":
      curState = { state: null };
      if (Globals._wsMgr) {
        curState = { state: Globals._wsMgr.GetDoc() };
        Globals._wsMgr.fDocContextProviderFn = reactContextSetStateFn;
        reactContextSetStateFn(curState);
        clearTimeout(Globals.gDocSubscriberId);
        return;
      }
      reactContextSetStateFn(curState);
      Globals.gDocSubscriberId = setTimeout(function () {
        SubscribeExternalModuleReactAPI(reactContextSetStateFn, stateMgrID);
      }, 100);
      break;
    case "sidebar":
      if (Globals._wsMgr) {
        Globals._wsMgr.fSidebarChange = reactContextSetStateFn["handleSideBarModeChange"];
        Globals._wsMgr.fSidebarMode = reactContextSetStateFn["sideBarMode"];
        Globals._wsMgr.fSetHighlightedRecordIds = reactContextSetStateFn["setHighlightedRecordIds"];
        clearTimeout(Globals.sidebarSubscriberId);
        return;
      }
      Globals.sidebarSubscriberId = setTimeout(function () {
        SubscribeExternalModuleReactAPI(reactContextSetStateFn, stateMgrID);
      }, 100);
      break;
    case "fileMgr":
      curState = { state: null };
      if (Globals._wsMgr) {
        Globals._wsMgr.fFileManagerState = reactContextSetStateFn["stateSetter"];
        Globals._wsMgr.fFileManagerContext = reactContextSetStateFn["contextSetter"];
        Globals._wsMgr.fFileManagerContextGetter = reactContextSetStateFn["contextGetter"];
        clearTimeout(Globals.fileMgrSubscriberId);
        return;
      }
      reactContextSetStateFn["stateSetter"](curState);
      Globals.fileMgrSubscriberId = setTimeout(function () {
        SubscribeExternalModuleReactAPI(reactContextSetStateFn, stateMgrID);
      }, 100);
      break;
    case "uiState":
      curState = { state: null };
      if (Globals._wsMgr) {
        Globals._wsMgr.routerNavigate = reactContextSetStateFn["navigate"];
        Globals._wsMgr.setSearchParams = reactContextSetStateFn["setSearchParams"];
        Globals._wsMgr.fUIElementStateManager = reactContextSetStateFn["uiElementSetter"];
        Globals._wsMgr.navToBoxLayout = reactContextSetStateFn["navToBoxLayout"];
        Globals._wsMgr.exitBoxLayout = reactContextSetStateFn["exitBoxLayout"];
        clearTimeout(Globals.uiStateSubscriberId);
        return;
      }
      Globals.uiStateSubscriberId = setTimeout(function () {
        SubscribeExternalModuleReactAPI(reactContextSetStateFn, stateMgrID);
      }, 100);
      break;
    case "viewmgr":
      curState = { state: null };
      if (Globals._wsMgr && Globals._wsMgr.GetChartTemplatesMgr()) {
        curState = { state: Globals._wsMgr.GetChartTemplatesMgr() };
        Globals._wsMgr.fViewContextProviderFn = reactContextSetStateFn;
        reactContextSetStateFn(curState);
        clearTimeout(Globals.gDocSubscriberId);
        return;
      }
      reactContextSetStateFn(curState);
      Globals.gViewMgrSubscriberId = setTimeout(function () {
        SubscribeExternalModuleReactAPI(reactContextSetStateFn, stateMgrID);
      }, 100);
      break;
    case "contextMenu":
      if (Globals._wsMgr) {
        Globals._wsMgr.fContextMenuHandler = reactContextSetStateFn;
        clearTimeout(Globals.contextMenuSubscriberId);
        return;
      }
      Globals.contextMenuSubscriberId = setTimeout(function () {
        SubscribeExternalModuleReactAPI(reactContextSetStateFn, stateMgrID);
      }, 100);
      break;
    case "recordInfo":
      if (Globals._wsMgr) {
        Globals._wsMgr.fRecordInfoHandler = reactContextSetStateFn;
        clearTimeout(Globals.recordInfoSubscriberId);
        return;
      }
      Globals.recordInfoSubscriberId = setTimeout(function () {
        SubscribeExternalModuleReactAPI(reactContextSetStateFn, stateMgrID);
      }, 100);
      break;
  }
};

window.getWindowWidth = function () {
  return window.innerWidth;
};

window.getWindowHeight = function () {
  return window.innerHeight;
};

export async function initializeCore() {
  await brandModulePromise;
  updateFavicon(false);

  return new Promise(resolve => {
    GlobalInit(resolve);
  });
}

export function initOrgChartNowApp(canvasSize, metadata) {
  var testHTML5 = CreateCanvas(); // document.createElement("canvas");
  if (!testHTML5.getContext) window.location = gBrowserLink; // "website/browser.html";

  var canvas = document.getElementById("basecanvas");

  if (canvas.getContext) {
    canvas["MyApp"] = null;
    window["MyApp"] = null;

    // The MFE shares the host page's document — it must never override the
    // host's own tab title.
    if (!isMfeContext() && document.title === "OrgChart") document.title = gAppName;

    if (metadata) {
      Globals._accountInfo.LoadInitParameters(metadata);
    } else {
      Globals._accountInfo.LoadURLParameters();
    }

    canvas.focus();

    var container = document.getElementById("canvasContainer");
    var rect = container.getBoundingClientRect();

    positionBaseCanvas(canvas, rect);
    setupCanvas(canvas, rect);

    const wsMgr = Globals._wsMgr;
    const myApp = Globals._app;

    myApp.InitApp(wsMgr);
    wsMgr.InitWS(canvas, kImageFiles);
    wsMgr.DoAppLoadingAnimation();
    myApp.RunApp();

    document.getElementById("loadFontIconSolid").style.font = '900 48px "Font Awesome 5 Pro"';
    document.getElementById("loadFontIconRegular").style.font = '400 48px "Font Awesome 5 Pro"';
    document.getElementById("loadFontIconLight").style.font = '300 48px "Font Awesome 5 Pro"';
    document.getElementById("loadFontIconDuotone").style.font = '900 48px "Font Awesome 5 Duotone"';

    canvas.addEventListener("mousemove", handleMouseMove(canvas), false);
    canvas.addEventListener("mousedown", handleMouseDown(canvas), false);
    window.addEventListener("mouseup", handleMouseUp(canvas), false);
    canvas.addEventListener("mouseenter", handleMouseEnter(canvas), false);
    canvas.addEventListener("dblclick", handleDoubleClick(canvas), false);
    canvas.addEventListener("contextmenu", handleRightClick(canvas), false);

    canvas.addEventListener("keydown", handleKeyDown, false);
    canvas.addEventListener("keyup", handleKeyUp, false);
    canvas.addEventListener("keypress", handleKeyPress, false);
    canvas.addEventListener("focus", handleCanvasFocus, false);
    canvas.addEventListener("blur", handleCanvasBlur, false);
    canvas.addEventListener("pointerdown", handleCanvasPointerDown, false);

    window.addEventListener("paste", handlePaste(canvas), false);
    window.addEventListener("cut", handleCut(canvas), false);
    window.addEventListener("copy", handleCopy(canvas), false);
    canvas.addEventListener("wheel", handleMouseWheel, { passive: true });

    //TOUCH SUPPORT - MOBILE (ANDROID MOBILE APPEARS TO USE THESE)
    canvas.addEventListener("touchstart", handleTouchStart, { passive: false });
    canvas.addEventListener("touchmove", handleTouchMove, { passive: false });
    canvas.addEventListener("touchcancel", handleTouchEnd);
    canvas.addEventListener("touchend", handleTouchEnd);

    //GESTURES ARE USED ON IPAD - NOT ANDROID
    canvas.addEventListener("gesturestart", handleGestureStart);
    canvas.addEventListener("gesturechange", handleGestureChange);
    canvas.addEventListener("gestureend", handleGestureEnd);

    //DRAG AND DROP FILE UPLOAD
    canvas.addEventListener("dragenter", handleDragEnter, false);
    canvas.addEventListener("dragleave", handleDragLeave, false);
    canvas.addEventListener("dragover", handleDragOver, false);
    canvas.addEventListener("drop", handleDragDrop, false);

    //Attempted Android support
    var inputElement = document.getElementById("hiddenInput");
    inputElement.addEventListener("keypress", handleMobileKeyPress); // handles all printing keys
    inputElement.addEventListener("keydown", handleMobileKeyDown); // handles all non-printing keys e.g Shift, Esc, delete
    inputElement.addEventListener("beforeinput", handleMobileKeyboardInput);

    canvas["MyApp"] = myApp;
    window["MyApp"] = myApp;
    DoSetOnBeforeUnload();
  }
}

//==============================================
// error event
window.onerror = function errorHandler(errorMsg, url, lineNumber) {
  // TODO consider logging / tracking events here / using alerts for better ux
  Globals._wsMgr.ClearAppLoadingAnimation(); // close any active loaders
};
